module.exports = function(PluginManager) {
  PluginManager.registerVisitorProfileProvider(require('./providers/cookies'));
  PluginManager.registerAudienceMatcher('cookies', require('./matchers/cookies'));
};
